var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-filter-price" }, [
    _c("div", { staticClass: "item-filter-price__inputs" }, [
      !_vm.loading
        ? _c("div", { staticClass: "item-filter-price__slider" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "item-filter-price__input-wrapper",
          style: _vm.loading ? "opacity: 0" : "opacity: 1",
        },
        [
          _c(
            "div",
            {
              staticClass: "item-filter-price__input d-flex align-items-center",
            },
            [
              _vm.lang !== "se"
                ? _c(
                    "span",
                    { staticClass: "item-filter-price__currency pr-1" },
                    [_vm._v(_vm._s(_vm.activeCurrency))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.price[0],
                    expression: "price[0]",
                  },
                ],
                attrs: {
                  min: _vm.minValue,
                  max: _vm.maxValue,
                  type: "number",
                  "aria-label": _vm.$translate(
                    "Ceres::Template.itemFilterPriceMin"
                  ),
                },
                domProps: { value: _vm.price[0] },
                on: {
                  blur: _vm.checkPriceInputs,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.price, 0, $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.lang === "se"
                ? _c(
                    "span",
                    { staticClass: "item-filter-price__currency pl-1" },
                    [_vm._v(_vm._s(_vm.activeCurrency))]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "item-filter-price__spacer" }, [
            _vm._v("-"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "item-filter-price__input d-flex align-items-center",
            },
            [
              _vm.lang !== "se"
                ? _c(
                    "span",
                    { staticClass: "item-filter-price__currency pr-1" },
                    [_vm._v(_vm._s(_vm.activeCurrency))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.price[1],
                    expression: "price[1]",
                  },
                ],
                attrs: {
                  min: _vm.minValue,
                  max: _vm.maxValue,
                  type: "number",
                  "aria-label": _vm.$translate(
                    "Ceres::Template.itemFilterPriceMax"
                  ),
                },
                domProps: { value: _vm.price[1] },
                on: {
                  blur: _vm.checkPriceInputs,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.price, 1, $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.lang === "se"
                ? _c(
                    "span",
                    { staticClass: "item-filter-price__currency pl-1" },
                    [_vm._v(_vm._s(_vm.activeCurrency))]
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item-filter-price__button" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-appearance btn-block",
          class: { disabled: _vm.isDisabled },
          attrs: {
            type: "button",
            title: _vm.$translate("Ceres::Template.itemApply"),
            "aria-label": _vm.$translate("Ceres::Template.itemFilterButton"),
          },
          on: {
            click: function ($event) {
              return _vm.triggerFilter()
            },
          },
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$translate("Ceres::Template.itemApply")) +
              "\n        "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }